module.exports = __webpack_public_path__ + "media/octagon-da29f252.svg";